import * as React from "react";

/**
 * Host-injected uploader for the posting preview image. The form package stays
 * free of API/presign concerns: the employer + admin apps each pass a handler
 * that presigns + PUTs to R2 and resolves the new object key + public URL.
 *
 * When no handler is provided the preview-image field is hidden — so older
 * callers (and any context that shouldn't allow images) render unchanged.
 */
export interface PreviewImageUploader {
  /** Presign + PUT one file. `onProgress` (0–100) drives the percent overlay. */
  onUpload: (
    file: File,
    onProgress: (percent: number) => void,
  ) => Promise<{ key: string; url: string }>;
}

const PreviewImageUploadContext =
  React.createContext<PreviewImageUploader | null>(null);

export const PreviewImageUploadProvider = PreviewImageUploadContext.Provider;

export function usePreviewImageUpload(): PreviewImageUploader | null {
  return React.useContext(PreviewImageUploadContext);
}
